import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrAreaType.ts
var t = () => e("areaType");
//#endregion
export { t as useTrAreaType };
